module.exports = __webpack_public_path__ + "static/media/img_audience.54366044.png";